export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/jon-profile-a9fdf790cfdc05e4af7823bef6685699.png";